import { secureTokenManager } from "../utils/secureTokenManager";

export const ApiCall = async (api, body, method, type) => {
  let requestbody;
  if (type !== "multipart") {
    requestbody =
      body !== null && body !== undefined && body !== ""
        ? {
            method: method,

            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + secureTokenManager.getAccessToken(),
            },
            body: JSON.stringify(body),
          }
        : {
            method: method,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + secureTokenManager.getAccessToken(),
            },
          };
  } else {
    requestbody =
      body !== undefined && body !== ""
        ? {
            method: method,
            headers: {},
            body: body,
          }
        : {
            method: method,
            headers: {},
          };
  }

  try {
    const res = await fetch(api, requestbody);
    return res.json();
  } catch (error) {
    return error;
  }
};

export const Base_URL = process.env.REACT_APP_BASE_URL || "https://prime-be-stg.parilabs.xyz"; // Fallback to dev URL if not set
